import { render, staticRenderFns } from "./PopupRiskInfoEp2_3x3.vue?vue&type=template&id=e9532d48&scoped=true"
import script from "./PopupRiskInfoEp2_3x3.vue?vue&type=script&lang=js"
export * from "./PopupRiskInfoEp2_3x3.vue?vue&type=script&lang=js"
import style0 from "./PopupRiskInfoEp2_3x3.vue?vue&type=style&index=0&id=e9532d48&prod&lang=scss&scoped=true"
import style1 from "./PopupRiskInfoEp2_3x3.vue?vue&type=style&index=1&id=e9532d48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9532d48",
  null
  
)

export default component.exports